import { assert, BadRequestError } from '@fragment/error-utils';

import { base64Decode, base64Encode } from '../encode';

export const encodeLedgerAccountLedgerId = (account: { ledgerId: string }) =>
  base64Encode(`le:${account.ledgerId}`);

export const encodeLedgerAccountId = (account: {
  ledgerId: string;
  id: string;
}) => base64Encode(`ac:${account.id}:le:${account.ledgerId}`);

export const isEncodedAccountId = (maybeEncoded: string) => {
  const bits = base64Decode(maybeEncoded).split(':');
  return bits[0] === 'ac' && bits[2] === 'le';
};

type DecodedLedgerAccountId = {
  ledgerId: string;
  accountId: string;
};
export const decodeLedgerAccountId = (
  encoded: string
): DecodedLedgerAccountId => {
  const decoded = base64Decode(encoded);

  const bits = decoded.split(':');
  assert(bits[0] === 'ac', BadRequestError, {
    message: `Provided with an invalid ledger account id: ${encoded}`,
  });
  assert(bits[2] === 'le', BadRequestError, {
    message: `Provided with an invalid ledger account id: ${encoded}`,
  });

  return {
    accountId: bits[1],
    ledgerId: bits[3],
  };
};
